<template>
  <li class="chapter-node">
    <div
      class="chapter-content"
      @mouseenter="selectChapter(chapter)"
      @mouseleave="clearChapter"
    >
      <!-- <span class="chapter-icon" @click="toggleExpand">
        <i :class="expandIcon"></i>
      </span> -->
      <span class="chapter-title" :title="chapter.chapterTitle">{{
        chapter.chapterTitle
      }}</span>
      <span
        class="chapter-actions"
        v-show="currentChapter.chapterTitle === chapter.chapterTitle"
      >
        <span class="action up" data-track-text="上移章节" aria-label="上移章节" v-show="!isFirst" @click.stop="moveUp"></span>
        <span
          class="action down"
          data-track-text="下移章节"
          aria-label="下移章节"
          v-show="!isLast"
          @click.stop="moveDown"
        ></span>
        <span
          class="action delete el-icon-customerarchivesrecycleBin"
          data-track-text="删除章节"
          aria-label="删除章节"
          @click.stop="deleteNode"
        >
        </span>
        <!-- <button @click.stop="moveUp" :disabled="isFirst">上移</button>
        <button @click.stop="moveDown" :disabled="isLast">下移</button>
        <button @click.stop="deleteNode">删除</button> -->
      </span>
    </div>

    <ul v-if="hasChildren && isExpanded" class="chapter-children">
      <chapter-node
        v-for="(child, childIndex) in chapter.chapterContents"
        :key="chapter.uuid"
        :chapter="child"
        :index="childIndex"
        :parent-chapters="chapter.chapterContents"
        @move-up="moveChapterUp"
        @move-down="moveChapterDown"
        @delete="deleteChapter"
      />
    </ul>
  </li>
</template>
<script>
export default {
  name: "ChapterNode",
  props: {
    chapter: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    parentChapters: {
      type: Array,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // isExpanded: true,
      currentChapter: "",
    };
  },
  computed: {
    hasChildren() {
      return (
        this.chapter.chapterContents && this.chapter.chapterContents.length > 0
      );
    },
    expandIcon() {
      return this.hasChildren
        ? this.isExpanded
          ? "el-icon-arrow-down"
          : "el-icon-arrow-right"
        : "el-icon-document";
    },
    isFirst() {
      return this.index === 0;
    },
    isLast() {
      return this.index === this.parentChapters.length - 1;
    },
  },
  methods: {
    selectChapter(chapter) {
      this.currentChapter = chapter;
    },
    clearChapter() {
      this.currentChapter = "";
    },
    toggleExpand() {
      if (this.hasChildren) {
        this.isExpanded = !this.isExpanded;
      }
    },
    moveUp() {
      console.log(123, {
        chapter: this.chapter,
        index: this.index,
        parentChapters: this.parentChapters,
      });
      this.$emit("move-up", {
        chapter: this.chapter,
        index: this.index,
        parentChapters: this.parentChapters,
      });
    },
    moveDown() {
      this.$emit("move-down", {
        chapter: this.chapter,
        index: this.index,
        parentChapters: this.parentChapters,
      });
    },
    deleteNode() {
      this.$confirm("删除后无法恢复，是否继续删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$emit("delete", {
            index: this.index,
            parentChapters: this.parentChapters,
          });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    moveChapterUp(payload) {
      this.$emit("move-up", payload);
    },
    moveChapterDown(payload) {
      this.$emit("move-down", payload);
    },
    deleteChapter(payload) {
      this.$emit("delete", payload);
    },
  },
};
</script>
<style  lang="less" scoped>
.chapter-node {
  list-style: none;
  margin: 5px 0;
  padding: 5px;
}
.chapter-content {
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
    border-radius: 4px;
  }
}
.chapter-icon {
  margin-right: 8px;
  cursor: pointer;
  color: #666;
}
.chapter-title {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.chapter-actions {
  margin-left: 5px;
  padding: 2px 6px;
  font-size: 12px;
  cursor: pointer;
  .action {
    display: inline-block;
    width: 18px;
    height: 18px;
    margin: 0 6px;
    cursor: pointer;
    color: #666;
    vertical-align: middle;
  }
  .up {
    background: url(../../assets/chat/up.png) center no-repeat;
    background-size: contain;
  }
  .down {
    background: url(../../assets/chat/down.png) center no-repeat;
    background-size: contain;
  }
  .delete {
    font-size: 16px;
  }
}
.chapter-children {
  margin-top: 5px;
  padding-left: 20px;
}
</style>
